import React, { useEffect, useState } from 'react';
import { t } from 'translates';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar'
import classNames from "classnames";
import isMobile from 'common/helpers/isMobile';

function MultipleSelect(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [filtersActive, setfiltersActive] = useState(props.filterCurrent);

  useEffect(() => {
    setfiltersActive(props.filterCurrent);
  }, [props.filterOpen]);

  useEffect(() => {
    if (isMobile) {
      let options = [];
      filtersActive.forEach(value => {
        const obj = props.options.find(o => o.value == value);
        options.push(obj.original_name)
      });
      props.change(props.name, filtersActive, props.label, options);
    }
  }, [filtersActive]);


  const toggle = (e) => {
    if (isMobile) {
      if (dropdownOpen && ( !e.target.classList.contains('sessions-new-filter__select-trigger') )) {
        return;
      }
    } else {
      setfiltersActive(props.filterCurrent);
    }
    setDropdownOpen(prevState => !prevState);
  };

  const setValue = (value) => {
    if (filtersActive.includes(value)) {
      setfiltersActive(filtersActive.filter((e)=>(e !== value)));
    } else {
      setfiltersActive([...filtersActive, value]);
    }
  };

  const selectSubmit = () => {
    let options = [];
    [...filtersActive].forEach(value => {
      const obj = props.options.find(o => o.value == value);
      options.push(obj.original_name)
    });
    props.change(props.name, filtersActive, props.label, options);
    toggle();
  };

  return (
    <Dropdown
      className={classNames("sessions-new-filter__select", {
        'sessions-new-filter__select--mobile': isMobile
      })}
      isOpen={dropdownOpen}
      toggle={toggle}
    >
      <DropdownToggle
        tag="button"
        data-toggle="dropdown"
        className="sessions-new-filter__select-trigger"
        aria-expanded={dropdownOpen}
      >
        {t(props.label, DT_SESSIONSNEW)}
        {props.filterCurrent.length > 0 && !isMobile && (
          <span>{props.filterCurrent.length}</span>
        )}
        {filtersActive.length > 0 && isMobile && (
          <span>{filtersActive.length}</span>
        )}
      </DropdownToggle>
      <DropdownMenu className="sessions-new-filter__select-dropdown">
        <PerfectScrollbar options={{wheelPropagation: false}}  className="sessions-new-filter__select-item-wrapper">
          {props.options.map((item) => (
            <button
              className={classNames("sessions-new-filter__select-item", {
                'is-active': filtersActive.includes(item.value)
              })}
              key={item.value}
              onClick={() => setValue(item.value)}
            >
              {item.name}
            </button>
          ))}
        </PerfectScrollbar>
        {!isMobile && (
          <button
            className="sessions-new-filter__select-apply"
            onClick={() => selectSubmit()}
          >
            {t("Apply", DT_SESSIONSNEW)}
          </button>
        )}
      </DropdownMenu>
    </Dropdown>
  );
}

export default  MultipleSelect;
